import React, { useState, cloneElement, useEffect } from 'react'
import { Autocomplete, TextField, Box, Button } from '@mui/material'
import LoadingButton from '@mui/lab/LoadingButton';
import Modal from '../../Modal'
import NewProjectSearchBar from '../../NewProjectSearchBar'
import styles from '../../../pages/Dashboard.module.scss'
import { useGeneral } from '../../../context/general'
import axios from 'axios';

export const FeedSearchModal = ({children, Type}) => {
    const { tickers,WatchlistData,setWatchlistData } = useGeneral()    
    const [ open, setOpen ] = useState(false)
    const [SelectedTickerData, setSelectedTickerData] = useState([])
    const [loading, setLoading] = React.useState(false);
    const [filteredTickers,setfilteredTickers] = useState([])

    const handleOpen = () => setOpen(true)
    const handleClose = () => setOpen(false)
    const HandleWatchlistAdd = async () =>{
        setLoading(true)
        // const resJson = await fetch('/api/insertWatchlistData', {
        //     method: 'POST',
        //     headers: { 'Content-Type': 'application/json' },
        //     body: JSON.stringify({'data':SelectedTickerData})
        // })
        const resJson = await axios({
            method: 'post',
            url: '/api/insertWatchlistData',
            data: {'data':SelectedTickerData}
        })
        const res = await resJson.data
        Array.isArray(res) && setWatchlistData(res)
        setLoading(false)
        setOpen(false)
        
        // try{
        //     fetch('/api/insertWatchlistData', {
        //         method: 'POST',
        //         headers: { 'Content-Type': 'application/json' },
        //         body: JSON.stringify({'data':SelectedTickerData})
        //     })
        //     .then(res => {
        //         if(res.status === 200) {
        //             console.log(res);
        //             console.log(res.json());
        //             setWatchlistData(res.json())
        //             setLoading(false)
        //             setOpen(false)
        //         }
        //         else{
        //             console.error('Failed to add to watchlist')
        //         }
        //     }
        //     ) 
        // }
        // catch{
        //     console.error('Failed to add to watchlist')
        // }
        // finally{
            
        //     }
    }

    const handleClick = () =>{
        HandleWatchlistAdd()
    }

    useEffect(()=>{
        setfilteredTickers(tickers?.filter(item=> !WatchlistData.map(x=> x.value).includes(item.value)))
        return () => {}
    },[tickers])

    return (
        <>
            {cloneElement(children, {onClick:handleOpen})}
            {Type != 'WatchlistHandler' &&<Modal open={open} handleClose={handleClose} hideHeader={true} overrideStyle={{cardContent:styles['search-modal']}}>
                <div>
                    {open && <NewProjectSearchBar 
                        textFieldProps={{paperProps:{elevation:10}}} 
                        open
                        handleClose={handleClose}
                        divider
                    />}
                </div>
            </Modal>}
            { Type == 'WatchlistHandler' && <Modal open={open} handleClose={handleClose} hideHeader={true} style={{width:500,height:'300px'}}>
                <Box width={800} height={200}>
                {open && filteredTickers.length>0 && Type=='WatchlistHandler'&&
                    <Autocomplete
                        multiple
                        id="tags-outlined"
                        options={filteredTickers}
                        getOptionLabel={(option) => option.name}
                        onChange={(event,value)=>{setSelectedTickerData(value)}}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Select Stocks"
                                placeholder="Select Stocks"
                            />
                        )}
                        style={{marginTop:'25px'}}
                />
                }
                </Box>
                <Box
                    style={{marginTop:'50px'}}
                    sx={{
                        mt: 1,
                        display: 'flex',
                        gap: 1,
                        flexDirection: { xs: 'column', sm: 'row-reverse' },
                    }}
                >
                    {/* <Button 
                        onClick={()=>{HandleWatchlistAdd();}}
                        variant="outlined" 
                        color="primary">Submit</Button> */}
                    <LoadingButton
                        size="medium"
                        onClick={handleClick}
                        loading={loading}
                        loadingIndicator="Loading…"
                        variant="outlined"
                        >
                        Submit
                    </LoadingButton>
                </Box>
            </Modal>}
        </>
    )
}

export default FeedSearchModal